import { Box, Card, CardContent, Typography } from '@mui/joy';

const MetricCard = ({ 
  title, 
  value, 
  icon, 
  gradientColors = ['#00A884', '#007E33'],
  onClick 
}) => {
  return (
    <Card
      onClick={onClick}
      sx={{
        background: `linear-gradient(135deg, ${gradientColors[0]} 0%, ${gradientColors[1]} 100%)`,
        color: 'white',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': { 
          transform: 'translateY(-4px)',
          boxShadow: '0 10px 25px rgba(0, 168, 132, 0.3)',
        },
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        minHeight: '120px',
        '@keyframes fadeInUp': {
          from: { opacity: 0, transform: 'translateY(20px)' },
          to: { opacity: 1, transform: 'translateY(0)' },
        },
        animation: 'fadeInUp 0.6s ease-out',
      }}
    >
      <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box>
            <Typography 
              level="h2" 
              sx={{ 
                color: 'white !important', 
                fontWeight: 700,
                fontSize: '2.5rem',
                lineHeight: 1,
                mb: 0.5
              }}
            >
              {value}
            </Typography>
            <Typography 
              level="body-sm" 
              sx={{ 
                color: 'white !important',
                opacity: 0.9,
                fontSize: '0.875rem',
                fontWeight: 500
              }}
            >
              {title}
            </Typography>
          </Box>
          {icon && (
            <Box
              sx={{
                fontSize: 48,
                opacity: 0.7,
                display: 'flex',
                alignItems: 'center',
                '& .material-symbols-outlined': {
                  fontSize: 'inherit',
                  fontFamily: 'Material Symbols Outlined'
                }
              }}
            >
              <span className="material-symbols-outlined">{icon}</span>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default MetricCard;